import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=6c6e6b56&"
import script from "./PriceTable.vue?vue&type=script&lang=js&"
export * from "./PriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports